import { useState, useEffect } from "react";
import {
  AccountInfo,
  InteractionRequiredAuthError,
  InteractionStatus,
  IPublicClientApplication,
} from "@azure/msal-browser";
import { IKeySitesData, ITileData, TileService } from "../services/TileService";
import { loginRequest } from "../authConfig";

export const useTileData = (
  inProgress: InteractionStatus,
  instance: IPublicClientApplication,
  forceRacc: boolean, //temporary for testing purposes
  forceDirectorate: string = "", //temporary for testing purposes
  forceServiceArea: string = "" //temporary for testing purposes
) => {
  const [tileData, setTileData] = useState<null | ITileData>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const tileService = new TileService();

    const fetchTileData = async () => {
      if (inProgress === InteractionStatus.None) {
        setIsLoading(true);
        try {
          const tileData = await tileService.getTileData(instance, forceRacc, forceDirectorate, forceServiceArea);
          setTileData(tileData);
        } catch (error) {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect({
              ...loginRequest,
              account: instance.getActiveAccount() as AccountInfo,
            });
          }
          console.error("Error fetching tile data:", error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchTileData();
  }, [inProgress, instance, forceRacc, forceDirectorate, forceServiceArea]);

  return { tileData, isLoading };
};

export const useKeySitesData = (
  inProgress: InteractionStatus,
  instance: IPublicClientApplication
) => {
  const [keySitesData, setKeySitesData] = useState<null | IKeySitesData[]>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const tileService = new TileService();

    const fetchTileData = async () => {
      if (inProgress === InteractionStatus.None) {
        setIsLoading(true);
        try {
          const keySitesData = await tileService.getKeySitesData(instance);
          setKeySitesData(keySitesData);
        } catch (error) {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect({
              ...loginRequest,
              account: instance.getActiveAccount() as AccountInfo,
            });
          }
          console.error("Error fetching key sites data:", error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchTileData();
  }, [inProgress, instance]);

  return { keySitesData, isLoading };
};